/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetUpdates200ResponseAnyOf } from './GetUpdates200ResponseAnyOf';
import {
    GetUpdates200ResponseAnyOfFromJSON,
    GetUpdates200ResponseAnyOfFromJSONTyped,
    GetUpdates200ResponseAnyOfToJSON,
    GetUpdates200ResponseAnyOfToJSONTyped,
} from './GetUpdates200ResponseAnyOf';

/**
 * 
 * @export
 * @interface GetUpdates200Response
 */
export interface GetUpdates200Response {
    /**
     * 
     * @type {string}
     * @memberof GetUpdates200Response
     */
    version: string;
    /**
     * 
     * @type {string}
     * @memberof GetUpdates200Response
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof GetUpdates200Response
     */
    checksum: string;
    /**
     * 
     * @type {number}
     * @memberof GetUpdates200Response
     */
    size?: number;
    /**
     * 
     * @type {string}
     * @memberof GetUpdates200Response
     */
    releaseDate?: string;
}

/**
 * Check if a given object implements the GetUpdates200Response interface.
 */
export function instanceOfGetUpdates200Response(value: object): value is GetUpdates200Response {
    if (!('version' in value) || value['version'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('checksum' in value) || value['checksum'] === undefined) return false;
    return true;
}

export function GetUpdates200ResponseFromJSON(json: any): GetUpdates200Response {
    return GetUpdates200ResponseFromJSONTyped(json, false);
}

export function GetUpdates200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUpdates200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'version': json['version'],
        'url': json['url'],
        'checksum': json['checksum'],
        'size': json['size'] == null ? undefined : json['size'],
        'releaseDate': json['releaseDate'] == null ? undefined : json['releaseDate'],
    };
}

export function GetUpdates200ResponseToJSON(json: any): GetUpdates200Response {
    return GetUpdates200ResponseToJSONTyped(json, false);
}

export function GetUpdates200ResponseToJSONTyped(value?: GetUpdates200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'version': value['version'],
        'url': value['url'],
        'checksum': value['checksum'],
        'size': value['size'],
        'releaseDate': value['releaseDate'],
    };
}

